import type { PrivateEventCrewView } from '../../api/privateEvents';
import { EditSection } from '../shared/EditSection';

import AddOnsNotesView from './AddOnsNotesView';
import ClientContactView from './ClientContactView';
import WhenWhatView from './WhenWhatView';

const noSave = () => Promise.resolve();

/** The teacher's details card: the admin card's sections, read-only, with the
 *  client and contact in place of the deal. */
export default function TeacherPrivateEventDetailsCard({ event }: { event: PrivateEventCrewView }) {
  return (
    <div className="nb-card" style={{ padding: '2px 18px 14px' }}>
      <EditSection
        first
        readOnly
        title="When & what"
        view={<WhenWhatView event={event} />}
        form={null}
        onSave={noSave}
      />
      <EditSection
        readOnly
        title="Client & contact"
        view={<ClientContactView event={event} />}
        form={null}
        onSave={noSave}
      />
      <EditSection
        readOnly
        title="Add-ons & notes"
        view={<AddOnsNotesView event={event} />}
        form={null}
        onSave={noSave}
      />
    </div>
  );
}
